import { Typography } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

interface UnFlaggedWarningMessageProps {
  isNoApproval: boolean;
  isYoursApproval: boolean;
  approvalIdAlertText: string;
}

const UnFlaggedWarningMessage = ({
  isNoApproval,
  isYoursApproval,
  approvalIdAlertText,
}: UnFlaggedWarningMessageProps) => {
  const isShowWarning = isNoApproval || !isYoursApproval;

  if (!isShowWarning) return null;

  const messageText = (() => {
    if (isNoApproval) {
      return "ไม่พบผู้อนุมัติของ Part นี้ โปรดติดต่อ PU Admin";
    } else if (!isYoursApproval) {
      return `คุณไม่ได้เป็นผู้อนุมัติของ Part นี้ ${approvalIdAlertText}`;
    }
    return "";
  })();

  const colorText = isNoApproval ? "error.light" : "warning.light";

  return (
    <Typography variant="body2" color={colorText} ml={1}>
      <WarningAmberIcon
        fontSize="small"
        sx={{ verticalAlign: "top", mr: 0.75 }}
      />
      {messageText}
    </Typography>
  );
};

export default UnFlaggedWarningMessage;
